import React, { useEffect } from "react";
import { Alert, Container } from "react-bootstrap";
import { useAnimations } from "../../Logic/Animations";
import { useHome } from "../../Logic/useHome";
import PlansCardStack from "../PlansCardStack";
import Style from "./Plans.module.scss";
import { useSelector } from "react-redux";
import Assets from "../Layouts/Assets";
import InfiniteDotLoader from "../../utils/InfiniteDotLoader";
import CommonModal from "../Modals/CommonModal";
import PaymentAddress from "../Modals/PaymentAddress";
import useAuthChecker from "../../Logic/Auth/useAuthChecker";

const Plans = () => {
  const { slideTopRef } = useAnimations();
  const { plans, plansData, buttonCallback, status ,closePaymentModal} = useHome();
  const { userProfileData, status:planStatus} = useSelector((state) => state.userData);
  const {isOpen } = useSelector((state) => state.payment);
  const { isAuthCompleted } = useAuthChecker();
  useEffect(() => {
    let renew= userProfileData?.is_package?"renew":""
    if(userProfileData && planStatus==="succeed" && isAuthCompleted){
      plans(renew);
     }
     if(!isAuthCompleted){
      plans(renew);
     }
    }, [userProfileData,isAuthCompleted]);

  return (
    <div className={Style.Plans}>
      <Container>
        {plansData?.length >= 1 ? (
          userProfileData.plan_payment_status === 1 && !userProfileData?.is_package ? (
            <>
              <div
                className={`section-title-block title-block-white center ${Style.heading}`}
              >
                <h2 ref={slideTopRef}>
                  <img
                    src={Assets?.tick}
                    alt="Tick"
                    className={Style.tickIcon}
                  />{" "}
                  Thank you!
                </h2>
                <p ref={slideTopRef}>
                  You activated <span>{userProfileData?.plan_name}</span>{" "}
                  plan!🎉
                </p>
              </div>
            </>
          ) : (
            <>
              <div className={`section-title-block center`}>
                <h2 ref={slideTopRef}>Choose a Plan to Start</h2>
                <p ref={slideTopRef}>
                  You can start accessing the Photofind by using the below
                  plans.
                </p>
                {userProfileData?.demo_package_expiry_status && (
                  <Alert variant={"warning"} dismissible className="w-100 my-4">
                    Your demo account has expired. Please renew your plan.
                  </Alert>
                )}
              </div>
            </>
          )
        ) : (
          ""
        )}
        <PlansCardStack
          plansData={plansData}
          buttonText={"Buy Now"}
          cardType={"main"}
          buttonCallback={buttonCallback}
        />
      <CommonModal
        showModal={isOpen}
        setShowModal={closePaymentModal}
        className={Style.payment_modal}
        content={<PaymentAddress/>}
      />
      </Container>
    </div>
  );
};

export default Plans;
